export default __webpack_public_path__ + "static/media/thumb_arlington_demo.88ca77ff.jpg";